import React from 'react';
import {ImageUploader} from '@xpertdox_js/xdcomponents';
import axiosConfig from '../../../../config/axios.config';

const ImageUpload = props => {

  return(
    <ImageUploader
      axiosConfig={axiosConfig}
      stagingType='email_asset'
      successCallback={assetDoc => {
        props.addAsset(assetDoc);
        props.clearTabs()
      }}
    />
  )
}

export default ImageUpload;
